import React from 'react';
import { LOCATION_TYPES } from '../constants';

const LocationSection = ({ 
  formData, 
  locations,
  isLoadingLocations,
  loading, 
  handleChange 
}) => {
  return (
    <>
      <div className="relative">
        <label className="block text-sm font-medium text-gray-700 mb-2 font-poppins">
          Location <span className="text-red-500">*</span>
        </label>
        <select
          name="location"
          value={formData.location}
          onChange={handleChange}
          disabled={loading || isLoadingLocations}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed text-sm font-poppins"
        >
          <option value="">Select Location</option>
          {LOCATION_TYPES.map((location) => (
            <option key={location.value} value={location.value}>
              {location.label}
            </option>
          ))}
        </select>
      </div>

      {/* School Selection */}
      {formData.location === 'SCHOOL_IMUS_CITY' && (
        <>
          <div className="relative">
            <label className="block text-sm font-medium text-gray-700 mb-2 font-poppins">
              School Level <span className="text-red-500">*</span>
            </label>
            <select
              name="schoolLevel"
              value={formData.schoolLevel}
              onChange={handleChange}
              disabled={loading || isLoadingLocations}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed text-sm font-poppins"
            >
              <option value="">Select School Level</option>
              {locations && locations.SCHOOL && Object.keys(locations.SCHOOL).length > 0 ? (
                Object.keys(locations.SCHOOL).map((level) => (
                  <option key={level} value={level}>
                    {level}
                  </option>
                ))
              ) : (
                <option disabled value="">No school levels available</option>
              )}
            </select>
            {isLoadingLocations && (
              <div className="flex items-center mt-2">
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600 mr-2"></div>
                <span className="text-sm text-gray-600 font-poppins">Loading school levels...</span>
              </div>
            )}
          </div>

          {formData.schoolLevel && (
            <div className="relative">
              <label className="block text-sm font-medium text-gray-700 mb-2 font-poppins">
                School Name <span className="text-red-500">*</span>
              </label>
              <select
                name="schoolName"
                value={formData.schoolName}
                onChange={handleChange}
                disabled={loading || isLoadingLocations}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed text-sm font-poppins"
              >
                <option value="">Select School</option>
                {locations && locations.SCHOOL && locations.SCHOOL[formData.schoolLevel]?.length > 0 ? (
                  locations.SCHOOL[formData.schoolLevel].map((school) => (
                    <option key={school} value={school}>
                      {school}
                    </option>
                  ))
                ) : (
                  <option disabled value="">No schools available for this level</option>
                )}
              </select>
              {isLoadingLocations && (
                <div className="flex items-center mt-2">
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600 mr-2"></div>
                  <span className="text-sm text-gray-600 font-poppins">Loading schools...</span>
                </div>
              )}
            </div>
          )}
        </>
      )}

      {/* SDO Department Selection */}
      {formData.location === 'SDO_IMUS_CITY' && (
        <div className="relative">
          <label className="block text-sm font-medium text-gray-700 mb-2 font-poppins">
            Department <span className="text-red-500">*</span>
          </label>
          <select
            name="department"
            value={formData.department}
            onChange={handleChange}
            disabled={loading || isLoadingLocations}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed text-sm font-poppins"
          >
            <option value="">Select Department</option>
            {locations && locations.SDO && locations.SDO.map((dept) => (
              <option key={dept} value={dept}>
                {dept}
              </option>
            ))}
          </select>
        </div>
      )}
    </>
  );
};

export default LocationSection; 